import './index.css'
import React, { useEffect, useState } from "react";
import SimpleSelection from "../../common/SimpleSelection";
import { TicketsFilterFormModel } from "../../../models/ticket.model";
import InputLabel from "../../common/InputLabel";
import Autocomplete from "../../common/Autocomplete";
import { TICKET_ELEMENT_ALL } from "../../../assets/appConstants/constants";
import SideMenu from "../../common/SideMenu";


interface TicketsFilterProps {
  openFilter: boolean,
  currentFilter: TicketsFilterFormModel,
  defaultFilterForm: TicketsFilterFormModel,
  setFilter: (filter: any) => void,
  resetFilter: () => void,
  handleCloseFilter: () => void,
  ticketStatusOptions: any[],
  ticketPrioritiesOptions: any[],
  companiesOptions: any[],
  elementsOptions: any[],
}

const TicketsFilter: React.FC<TicketsFilterProps> = ({ openFilter, currentFilter,
  defaultFilterForm, setFilter, resetFilter, handleCloseFilter, ticketStatusOptions,
  ticketPrioritiesOptions, companiesOptions, elementsOptions }) => {

  const [filterForm, setFilterForm] = useState<TicketsFilterFormModel>(currentFilter)

  useEffect(() => {
    if (openFilter) {
      setFilterForm(typeof currentFilter.number === 'object' ?
        { ...currentFilter, number: '' }
        : currentFilter)
    }
  }, [openFilter])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement> | { 'target': { 'name': any, 'value': any } }): void => {
    setFilterForm({
      ...filterForm,
      [event.target.name]: event.target.value
    });
  }

  const handleSelection = (key: string, value: string): void => {
    setFilterForm({
      ...filterForm,
      [key]: value
    });
  }

  const onSubmit = () => {
    setFilter(filterForm)
  }

  const onReset = () => {
    setFilter(defaultFilterForm)
    resetFilter()
  }

  const filterBody = (<>
    <div className="tickets-filters-box">
      <div className="tickets-filters-items">
        <div className="ticket-filters-item">
          <InputLabel
            label='Ticket'
            placeholder="Número"
            name='number'
            value={filterForm.number}
            onChange={handleChange}
          />
        </div>

        <div className="ticket-filters-item">
          <Autocomplete
            label="Elemento"
            placeholder="Elemento"
            options={elementsOptions}
            name={"element"}
            value={filterForm.element}
            handleSelection={handleSelection}
            valueOnClear={TICKET_ELEMENT_ALL}
          />
        </div>

        <div className="ticket-filters-item">
          <InputLabel
            label='Alarma'
            placeholder="Alarma"
            name='alarm'
            value={filterForm.alarm}
            onChange={handleChange}
          />
        </div>

        <div className="ticket-filters-item">
          <SimpleSelection
            label="Estado"
            options={ticketStatusOptions}
            name={"status"}
            value={filterForm.status}
            onChange={handleChange}
          />
        </div>

        <div className="ticket-filters-item">
          <SimpleSelection
            label="Prioridad"
            options={ticketPrioritiesOptions}
            name={"priority"}
            value={filterForm.priority}
            onChange={handleChange}
          />
        </div>

        <div className="ticket-filters-item">
          <SimpleSelection
            label="Compañía"
            options={companiesOptions}
            name={"company"}
            value={filterForm.company}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className='ticket-filters-actions-bar'>
        <span>
          <button className='ticket-filters-bottom-bar-cancel-btn' onClick={onReset}>Restablecer</button>
        </span>
        <span>
          <button className='ticket-filters-bottom-bar-save-btn' onClick={onSubmit}>Aplicar</button>
        </span>
      </div>

    </div>
  </>)

  return (
    <>
      <SideMenu
        title="Filtrar Resultados"
        openMenu={openFilter}
        handleCloseSideMenu={handleCloseFilter}
        children={filterBody}

      />
    </>
  )

}

export default TicketsFilter